import React from "react";

const UserAvatar = ({ user }) => {

  return (
    <div>
      <div className="profile-avatar-wrapper">
        <img
          src={user?.avatar?.url || 'default-avatar.png'}
          alt={user.name}
          className="profile-avatar"
        />
      </div>
      
    </div>
  );
};

export default UserAvatar;
